module.exports = __webpack_public_path__ + "static/media/brooke-lark-nTZOILVZuOg-unsplash.a75d4254.jpg";